import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Icon from "../../../../../../base/icons/icon/index.js";
import { getIcon } from "../../../utils/index.js";
import * as S from "./styled.js";
const HeaderBadges = ({ config ={} , discount  })=>{
    const { icon =false , iconName ='' , deal =false , product ='' , isBlackfriday =false  } = config;
    const showOffer = !icon && !!discount;
    const hasBadge = icon || showOffer;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "HeaderBadges",
        children: hasBadge && /*#__PURE__*/ _jsxs(S.IconBadgeMobile, {
            $variant: product,
            "data-testid": "HeaderBadgesIconWrapper",
            className: classNames({
                'is-deal': showOffer || deal,
                'is-blackfriday': isBlackfriday
            }),
            children: [
                icon && /*#__PURE__*/ _jsx(Icon, {
                    className: `nico-${iconName || getIcon(product)}`
                }),
                showOffer && !icon && /*#__PURE__*/ _jsx("span", {
                    "data-testid": "HeaderBadgesIconDiscount",
                    className: "discount",
                    children: discount
                })
            ]
        })
    });
};
export default HeaderBadges;

//# sourceMappingURL=index.js.map